var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg724(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 77.615,
    y1: 32.483,
    x2: 444.043,
    y2: 429.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34ca82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37a477"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -63.089,
    y1: 184.357,
    x2: 249.34,
    y2: 579.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6cbcc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 271.543,
    y1: -80.084,
    x2: 583.972,
    y2: 315.273,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.281,
    y1: 134.724,
    x2: 312.147,
    y2: 530.081,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -37.166,
    y1: 163.872,
    x2: 275.262,
    y2: 559.229,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 228.003,
    y1: -45.676,
    x2: 540.431,
    y2: 349.681,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 143.423,
    y1: 21.162,
    x2: 455.851,
    y2: 416.519,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 256.153,
    y1: -67.922,
    x2: 568.581,
    y2: 327.435,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 93.81,
    y1: 60.369,
    x2: 406.238,
    y2: 455.726,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 189.404,
    y1: -15.174,
    x2: 501.833,
    y2: 380.183,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 44.579,
    y1: 99.273,
    x2: 357.008,
    y2: 494.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 84.352,
    y1: 244.699,
    x2: 385.209,
    y2: 358.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e4154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b2129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 99.746,
    y1: 204.218,
    x2: 400.603,
    y2: 318.004,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 108.496,
    y1: 180.861,
    x2: 409.353,
    y2: 294.647,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 119.612,
    y1: 151.468,
    x2: 420.47,
    y2: 265.254,
    xlinkHref: "#linear-gradient-12"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Service 24 Hours") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.667,256A213.3,213.3,0,0,1,388.112,88.534H355.661a10.667,10.667,0,0,0,0,21.333H416A10.667,10.667,0,0,0,426.667,99.2V38.859a10.667,10.667,0,0,0-21.334,0v36.12A234.665,234.665,0,0,0,90.068,421.932a10.665,10.665,0,0,0,15.083-15.083A211.938,211.938,0,0,1,42.667,256Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.771,447.953c-6.052-2.943-12.042-6.219-17.8-9.729a10.666,10.666,0,1,0-11.115,18.208c6.339,3.87,12.932,7.469,19.594,10.709a10.667,10.667,0,0,0,9.323-19.188Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M448.047,162.969a10.665,10.665,0,1,0,19.2-9.3c-3.214-6.641-6.807-13.234-10.677-19.6a10.668,10.668,0,0,0-18.229,11.089C441.859,150.945,445.125,156.938,448.047,162.969Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M281.307,467.839c-6.734.8-13.547,1.276-20.255,1.437A10.665,10.665,0,0,0,261.3,490.6c.083,0,.172,0,.255,0,7.375-.172,14.859-.7,22.255-1.573a10.667,10.667,0,1,0-2.5-21.187Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M220.6,466.391c-6.635-1.11-13.307-2.552-19.828-4.3a10.669,10.669,0,1,0-5.511,20.614c7.178,1.917,14.521,3.506,21.829,4.724a10.666,10.666,0,1,0,3.51-21.041Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480.193,250.857a10.669,10.669,0,0,0-10.927,10.4c-.172,6.745-.662,13.558-1.464,20.255a10.675,10.675,0,0,0,9.328,11.86,11.789,11.789,0,0,0,1.281.073,10.671,10.671,0,0,0,10.579-9.4c.875-7.36,1.416-14.844,1.6-22.256A10.663,10.663,0,0,0,480.193,250.857Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M447.453,372.865a10.679,10.679,0,0,0-14.818,2.828c-3.791,5.578-7.89,11.041-12.192,16.234a10.664,10.664,0,1,0,16.427,13.6c4.729-5.708,9.245-11.713,13.411-17.849A10.662,10.662,0,0,0,447.453,372.865Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M462.151,200.969c1.729,6.5,3.167,13.166,4.276,19.833a10.669,10.669,0,0,0,10.511,8.922,10.927,10.927,0,0,0,1.755-.146,10.665,10.665,0,0,0,8.776-12.271c-1.214-7.333-2.8-14.679-4.7-21.828a10.667,10.667,0,0,0-20.615,5.49Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M391.745,420.589c-5.214,4.312-10.677,8.411-16.235,12.177a10.665,10.665,0,1,0,11.969,17.656c6.115-4.141,12.12-8.646,17.86-13.386a10.669,10.669,0,1,0-13.594-16.447Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M472.583,314.214a10.677,10.677,0,0,0-13.4,6.921c-2.041,6.4-4.427,12.792-7.088,19.006a10.665,10.665,0,1,0,19.6,8.406c2.937-6.839,5.562-13.886,7.807-20.932A10.658,10.658,0,0,0,472.583,314.214Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M339.938,452.182c-6.152,2.636-12.547,5.016-19.011,7.078a10.665,10.665,0,1,0,6.479,20.323c7.11-2.265,14.151-4.885,20.927-7.786a10.668,10.668,0,0,0-8.4-19.615Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M165.792,234.208c0-17.481-11.5-31.489-29.287-35.69a44.413,44.413,0,0,0-50.047,23.531,10.668,10.668,0,1,0,19.084,9.542,22.906,22.906,0,0,1,26.062-12.31c3.016.711,12.854,3.893,12.854,14.927,0,11.125-12.849,19.706-26.453,28.792-15.317,10.224-32.672,21.813-32.672,41A10.667,10.667,0,0,0,96,314.667h59.125a10.667,10.667,0,1,0,0-21.334h-42.26c4.468-4.234,10.786-8.453,16.984-12.593C146.7,269.49,165.792,256.74,165.792,234.208Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M266.667,269.333A10.667,10.667,0,0,0,256,258.667h-8.667V202a10.668,10.668,0,0,0-18.989-6.674l-54,67.335A10.669,10.669,0,0,0,182.667,280H226v30a10.667,10.667,0,1,0,21.333,0V280H256A10.667,10.667,0,0,0,266.667,269.333ZM226,258.667H204.9L226,232.349Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M321.26,185.542a10.646,10.646,0,0,0-12.552,8.367l-24,120a10.666,10.666,0,1,0,20.917,4.188l24-120A10.662,10.662,0,0,0,321.26,185.542Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M376,314.672a10.678,10.678,0,0,0,9.849-6.568l40-96A10.665,10.665,0,0,0,416,197.333H362a10.667,10.667,0,1,0,0,21.334h38L366.156,299.9A10.68,10.68,0,0,0,376,314.672Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg724);
export default __webpack_public_path__ + "static/media/724.95c840f1993f87a96366f8e984bcf02b.svg";
export { ForwardRef as ReactComponent };